import React, {useEffect, useState, Fragment} from 'react';
import {Button, Col, Row} from 'react-bootstrap';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import {service as ProcedureService} from "../../../Services/ProcedureService";
import {service as SampleEventPhaseService} from "../../../Services/SampleEventPhaseService";
import {service as SampleEventService} from "../../../Services/SampleEventService";
import {StreamBankLink} from "../../Common/StreamBankLink";
import IconUtils from "../../../../../monitoring/src/Utils/IconUtils";
import DateUtils from "../../../../../monitoring/src/Utils/DateUtils";
import {usePrimeCache} from "../../../Hooks/ServiceHooks";
import * as PropTypes from "prop-types";

function EventListItem(props) {
    const {event} = props;

    if(!usePrimeCache([ProcedureService])) {
        return null;
    }
    
    const procedure = ProcedureService.CachedValueById(event.procedureId)?.result;
    const eventDate = DateUtils.FormatToLocalDateTime(event.startDate, "MMM d, yyyy");
    
    return <dd>
        <StreamBankLink
            Context={
                event?.ConservationActionSampleEvents?.[0]?.ConservationAction?.ContextNodeDetails?.link
                + "/" + event.sampleEventId
            }
            Tool="summary"
        >
            <FontAwesomeIcon icon={IconUtils.GetIcon(procedure?.code, "fas")} fixedWidth/>
            <span>{eventDate} </span>
            { event.otherPurpose && <span className="other-purpose">- {event.otherPurpose}</span> }
            { SampleEventService.eventIsScheduled(event) && <span className="is-scheduled">- <FontAwesomeIcon icon={['fas', 'calendar']}/> Scheduled</span> }
        </StreamBankLink>
    </dd>;
}

EventListItem.propTypes = {
    event: PropTypes.any,
    procedure: PropTypes.any
};
export const RecentEvents = (props) => {
    const [sampleEvents, setSampleEvents] = useState(null);
    const [sampleEventPhaseIds, setSampleEventPhaseIds] = useState(null);

    useEffect(() => {
        if (props.contextNodeId) {
            loadData();
        }
    }, [props.contextNodeId]);
    
    usePrimeCache([SampleEventPhaseService]);
    
    const sampleEventPhases = SampleEventPhaseService.CachedValues()?.result;

    const loadData = () => {
        Promise.allSettled([
            SampleEventService.GetWithContext({
                contextNodeId: props.contextNodeId,
                sampleEventTypeId: 1,
            })
        ]).then(([sampleEventResult, procedureResult, sampleEventPhaseResult]) => {
            console.log(123, sampleEventResult)
            // Filter by recent 2 sample event phases
            const allPhaseIds = sampleEventResult.value.result.map((event) => event.sampleEventPhaseId).sort().reverse();
            const uniquePhaseIds = new Set(allPhaseIds);
            const recentEvents = sampleEventResult?.value?.result;//.sort((a, b) => b.sampleEventPhaseId - a.sampleEventPhaseId);
            // .splice(0, 20);

            setSampleEvents(recentEvents);
            setSampleEventPhaseIds(Array.from(uniquePhaseIds).splice(0, 2));
        });
    };
    
    const renderEventList = () => {
        if(sampleEventPhaseIds === null || !sampleEventPhases) {
            return <dd>Loading...</dd>;
        }
        
        let result = sampleEventPhaseIds.map(phaseId => {
            const currentPhase = sampleEventPhases.find(phase => phaseId === phase.sampleEventPhaseId);
            return <Fragment key={phaseId}>
                <dt>{currentPhase?.name}</dt>
                {
                    sampleEvents.filter(event => event.sampleEventPhaseId === phaseId).map(event =>
                        <EventListItem
                            key={event.sampleEventId}
                            event={event}
                        />
                    )
                }
            </Fragment>
        })
        
        if(!result.length) {
            return "No Events";
        }

        result = result.concat(
            <Fragment key="more">
                <dt><StreamBankLink Tool="events">
                    <Button className="sb-recent-events-more-btn">More</Button>
                </StreamBankLink></dt>
            </Fragment>
        );
        
        return result;
    }

    return (
        <Row className="sb-recent-events-list">
            <Col xs={12} className="sb-recent-events-list-node">
                <h2 className="sb-children-list-title">Recent Events</h2>
                <dl className="sb-recent-events-list">
                    { renderEventList()}
                </dl>
            </Col>
        </Row>
    )
};


